module.exports = __webpack_public_path__ + "img/amhl.16bb4326.png";